export default "__VITE_ASSET__DNm_RDHt__"